import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor", true)!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_QuillEditor, {
      content: _ctx.content,
      "onUpdate:content": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content) = $event)),
        _ctx.updateContent
      ],
      options: _ctx.editorOptions,
      contentType: "html"
    }, null, 8, ["content", "options", "onUpdate:content"])
  ]))
}